<template>
  <div class="listing-page">
    <header class="header">
      <div class="row">
        <div class="columns small-12 medium-8">
          <div class="text-lesson-plan subheader">
            Premium Classroom-ready Unit &amp; Lesson Plans
          </div>
          <h1>{{ title }}</h1>
          <p>
            {{ description }}
            <nuxt-link :to="localePath('/unit-plans/')" title="View unit plans">
              View unit plans &rarr;
            </nuxt-link>
          </p>
        </div>
      </div>
    </header>

    <resources-list :pagination="true" :params="params" :available-filters="availableFilters" />
  </div>
</template>

<script>
/* Lesson Plans
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components: ResourcesList
 * @methods:
 */

import { mapGetters } from 'vuex';
import ResourcesList from '~/components/resource/ResourcesList.vue';

export default {
  name: 'LessonPlansIndex',
  components: {
    ResourcesList,
  },
  data() {
    return {
      title: 'Lesson Plans',
      description:
        'Hundreds of unique Lesson Plans ready-to-use in your classroom. Each lesson contains specifically designed, engaging teaching resources.',
      params: {
        country: this.$i18n.locale,
        orderBy: 'created',
        direction: 'asc',
        payload: 'basic',
        perPage: 30,
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        types: ['lesson-plan'],
      },
      availableFilters: [
        'learning_areas',
        'year_levels',
        'availability',
        'file_formats',
        'publishers',
      ],
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title + ' - Curriculum Aligned' },
        { hid: 'description', name: 'description', content: this.description },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  //nuxtI18n: false,
  computed: {
    ...mapGetters(['lessonPlans']),
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
};
</script>
